import { formatBaht } from '@xver/utils/number';
import { IconCurrencyBaht } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

interface BalanceProps {
    balance: number;
    onDrawer?: boolean;
}

export default function Balance({ balance, onDrawer }: BalanceProps) {
    const { t } = useTranslation('common');
    const navigate = useNavigate();

    return (
        <div
            className={`p-1 w-full h-12 grid grid-cols-[auto_72px] sm:grid-cols-[auto_64px] rounded-md border-[0.5px] border-line ${onDrawer ? 'bg-surface-2' : 'bg-surface-3'} sm:h-9`}
        >
            <div className="w-full max-w-full px-2.5 flex flex-row justify-start items-center text-base sm:px-1 sm:text-sm">
                <span className="mr-1 text-base text-fg/68">{t('balance.credit')}</span>
                <span className="max-w-33.5 text-base font-bold truncate">
                    {formatBaht(balance, 0, 3)}
                </span>
                <IconCurrencyBaht size={onDrawer ? 20 : 18} stroke={2.5} className="mb-0.5" />
            </div>
            <button
                type="button"
                onClick={() => navigate('/platform/topup')}
                className="w-full max-w-full rounded-sm border-[0.5px] transition-all duration-100 cursor-pointer border-line bg-[#22c55e]/20 hover:bg-[#22c55e]/30"
            >
                <span className="inline-flex items-center text-[14px] font-bold text-[#4ade80] light:text-[#166534] text-center">
                    {t('balance.topUp')}
                </span>
            </button>
        </div>
    );
}
